import React, { useEffect } from 'react';
import WebkitCallback from '@/lib/webkit-callback';
import { jsx as _jsx } from "react/jsx-runtime";

var AppMessage = function AppMessage(_ref) {
  var scope = _ref.scope,
      command = _ref.command,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? [] : _ref$params;
  var encodedParams = params.map(encodeURIComponent).join(',');
  var message = encodedParams.length ? [scope, command, encodedParams].join(':') : [scope, command].join(':');

  var componentDidMount = function componentDidMount() {
    WebkitCallback.postMessage(message);
  };

  useEffect(componentDidMount, []);
  return /*#__PURE__*/_jsx("span", {});
};

export default AppMessage;